import React from 'react';
import { useTenant } from './useTenant';
import ContextualLoginPage from './ContextualLoginPage';
import { Loader2 } from 'lucide-react';

const LoginWithBookingContext: React.FC = () => {
  const tenant = useTenant();

  if (tenant.isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
          <p className="text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  return <ContextualLoginPage companyName={tenant.name} />;
};

export default LoginWithBookingContext;
